import HeaderBar from "../../../components/header/headerBar";
import MainButton from "../../../components/button/mainButton";
import { useEffect, useState } from "react";
import { Table, TableColumn } from "../../../components/table";
import {
  Select,
  Input,
  Form,
  Button,
  Row,
  Col,
  Card,
  Modal,
  Space,
  Pagination,
} from "antd";
import { Icon } from "@iconify/react";
import "../../../assets/styles/admin/medicalequip.scss";
import "../../../assets/styles/ant/confirmModal.scss";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import axios from "axios";

import { TwitterPicker, GithubPicker } from "react-color";

const MedicalEquipment = () => {
  let [formMedicalEquip] = Form.useForm();
  const { TextArea } = Input;
  const { confirm } = Modal;
  const [isOpen, setIsOpen] = useState(false);
  const [state, setState] = useState<any>([]);
  const [optGetSelect, setOptGetSelect] = useState<any>([]);
  const [treatmentTypeTree, setTreatmentTypeTree] = useState<any>([]);
  const [stockTypeTree, setStockTypeTree] = useState<any>([]);

  const [optBranch, setOptBranch] = useState<any>([]);
  const [optTypeUsed, setOptTypeUsed] = useState<any>([]);
  const [countPage, setCountPage] = useState(1);
  const [page, setPage] = useState(1);
  const { Option } = Select;
  const [id, setId] = useState("");

  const [types, setTypes] = useState("");
  const [modalDelete, setModalDetele] = useState(false);
  const [isColor, setColor] = useState<any>({ background: "#00D084" });
  const [isDisable, setIsDisable] = useState<any>([]);
  const [dataSearch, setDataSearch] = useState<any>([]);

  const handleChangeComplete = (color: any) => {
    // console.log("color=>>>>", color);
    setColor({ background: color.hex });
  };
  const searchData = (e: any) => {
    const dataSearchs = e;
    const setGet = dataSearch.typeSearch;
    console.log("value :===>", dataSearchs, "<======>", "select =>>>> ");
  };
  const istypes = [
    // { value: "code", label: "Code" },
    { value: "name", label: "Name" },
  ];
  const getAPIs = async () => {
    await axios
      .get(`/medical-equipments?page=${page}&category=all&branch=all&search=`)
      .then((res) => {
        console.log(res.data);

        setState(res?.data?.data);
        setCountPage(res?.data?.pages);
        setPage(res?.data?.page);
      });
  };

  const Onsubmit = (values: any) => {
    // console.log("CREATE======>", values);
    values = {
      ...values,
      colors: isColor.background,
    };
    console.log("set=>>><><><><.", values);

    if (types == "CREATE") {
      createDatas(values);
    } else if (types == "UPDATE") {
      updateDatas(values);
    }
  };
  const createDatas = async (values: any) => {
    console.log("values create", values);

    if (values) {
      const body = values;
      await axios.post(`/medical-equipments`, body).then((res) => {
        setTimeout(() => getAPIs(), 200);
        setIsOpen(false);
      });
    }
    formMedicalEquip.setFieldsValue({
      name: null,
      serialNumber: null,
      branch: null,
    });
  };
  const getOneById = (value: any) => {
    // console.log("values", value);

    setId(value?._id);
    const cateOptTypeUsed = [];
    for (let i = 0; i < value?.categoryUses?.length; i++) {
      cateOptTypeUsed.push(
        <Option
          value={value?.categoryUses[i]?._id}
          key={value?.categoryUses[i]?._id}
        >
          {value?.categoryUses[i]?.name}
        </Option>
      );
    }
    // console.log("values", cateOptTypeUsed);
    setColor({ background: value?.colors });
    formMedicalEquip.setFieldsValue({
      name: value?.name,
      serialNumber: value?.serialNumber,
      stock: value?.stock,
      branch: value?.branch?._id,
      categoryUses: cateOptTypeUsed,
    });
  };
  const updateDatas = async (values: any) => {
    const cateOptTypeUsed = [];
    console.log("values", values);

    if (values?.categoryUses[0]?.props !== undefined) {
      for (let i = 0; i < values?.categoryUses?.length; i++) {
        cateOptTypeUsed.push(values?.categoryUses[i]?.props?.value);
      }
      const body = {
        ...values,
        categoryUses: cateOptTypeUsed,
      };

      values = body;
    }
    await axios.patch(`medical-equipments/${id}`, values).then((res) => {
      setTimeout(() => getAPIs(), 200);
      setIsOpen(false);
    });
  };
  const deleteData = (id: any) => {
    axios.delete(`/medical-equipments/${id}`).then((res) => {
      setTimeout(() => getAPIs(), 200);
    });
  };

  const getBranch = async () => {
    const branchname = await axios.get(`/branches`);
    const cateOptBranch = [];

    for (let i = 0; i < branchname?.data?.data.length; i++) {
      cateOptBranch.push(
        <Option
          value={branchname?.data?.data[i]?._id}
          key={branchname?.data?.data[i]?.name}
        >
          {branchname?.data?.data[i]?.name}
        </Option>
      );
    }
    setOptBranch(cateOptBranch);
  };

  const getTypeUsed = async () => {
    const typeUsed = await axios.get(`/product-categories`);
    const cateOptTypeused = [];

    for (let i = 0; i < typeUsed?.data?.data.length; i++) {
      cateOptTypeused.push(
        <Option
          value={typeUsed?.data?.data[i]?._id}
          key={typeUsed?.data?.data[i]?._id}
        >
          {typeUsed?.data?.data[i]?.name}
        </Option>
      );
    }
    setOptTypeUsed(cateOptTypeused);
  };

  function showDeleteConfirm(id: any, name: any) {
    confirm({
      title: "",
      content: (
        <>
          <div>
            <Icon
              icon="lucide:alert-circle"
              color="#FF6760"
              width="10.6%"
              height="10.6%"
              style={{ marginBottom: "28px" }}
            />
          </div>
          <div>{`ต้องการลบรายการ ${name} ออกหรือไม่ ?`}</div>
          <div>{`Are you sure delete ${name} from list?`}</div>
        </>
      ),
      icon: <ExclamationCircleOutlined />,
      // content: "Some descriptions",
      autoFocusButton: null,
      okText: "ตกลง / Submit",
      okType: "danger",
      cancelText: "ยกเลิก / Cancel",
      onOk() {
        // console.log("OK");
        deleteData(id);
      },
      onCancel() {
        // console.log("Cancel");
      },
    });
  }
  const onchangePage = (page: any) => {
    setPage(page);
    getAPIs();
  };
  const onChangeTypeTree = (value: string[]) => {
    // console.log("onChangeTypeTree", value);
    // if (value.length > 0) {
    //   setIsGIFT(true);
    // } else {
    //   setIsGIFT(false);
    // }
    // setCategories(value);
    // const join = value.join(",");
    // // console.log("join =>", join);
    // setTreatmentType(join);
  };
  const onChangeStockTypeTree = (value: string[]) => {
    // console.log("onChangeStockTypeTree", value);
    // if (value.length > 0) {
    //   setIsGIFT(true);
    // } else {
    //   setIsGIFT(false);
    // }
    // setCategories(value);
    // const join = value.join(",");
    // // console.log("join =>", join);
    // setTreatmentType(join);
  };
  const gridStyle: React.CSSProperties = {
    width: "40px",
    borderRadius: "5px",
    height: "40px",
    backgroundColor: isColor.background,
    textAlign: "center",
  };
  const getTreatmentTypeTree = async () => {
    axios.get(`product-categories?page=`).then(async (res) => {
      const category = res?.data?.data;
      console.log(category);

      const test = category.map((x: any, key: number) => ({
        ...x,
        value: x._id,
        title: x.name,
      }));
      const children = [];
      for (let i = 0; i < test.length; i++) {
        children.push(<Option key={test[i].value}>{test[i].title}</Option>);
      }
      setTreatmentTypeTree(children);
    });
  };
  const getStockTypeTree = async () => {
    // axios.get(`product-categories?page=`).then(async (res) => {
    const category = [
      {
        code: "AETEST",
        name: "nameAETEST",
        _id: "12",
      },
    ];
    const test = category.map((x: any, key: number) => ({
      ...x,
      value: x._id,
      title: x.name,
    }));
    const children = [];
    for (let i = 0; i < test.length; i++) {
      children.push(<Option key={test[i].value}>{test[i].title}</Option>);
    }
    setStockTypeTree(children);
    // });
  };
  useEffect(() => {
    getAPIs();
    getBranch();
    getTypeUsed();
    getTreatmentTypeTree();
    getStockTypeTree();
  }, []);
  return (
    <>
      <HeaderBar title="MEDICAL EQUIPMENT LIST" />
      <div style={{ padding: "0px 40px" }}>
        <Modal visible={isOpen} footer={null} onCancel={() => setIsOpen(false)}>
          <Form form={formMedicalEquip} onFinish={Onsubmit} layout="vertical">
            <h4>{types} EQUIPMENT</h4>
            <Row className="formmodal-medical">
              <Col xs={18} sm={18} md={18} lg={18}>
                <Form.Item
                  label="ชื่อเครื่อง/Name"
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Name!",
                    },
                  ]}
                >
                  <Input type="text" />
                </Form.Item>
                <Form.Item
                  label="เลขที่/Serial Number"
                  name="serialNumber"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Serial Number!",
                    },
                  ]}
                >
                  <Input type="number" />
                </Form.Item>
                <Form.Item
                  label="หัวที่ใช้/Head"
                  name="stock"
                  rules={[
                    { required: true, message: "Please input your Head!" },
                  ]}
                >
                  <Select
                    mode="multiple"
                    allowClear
                    // dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                    style={{ width: "100%" }}
                    showSearch
                    onChange={onChangeStockTypeTree}
                  >
                    {stockTypeTree}
                  </Select>
                </Form.Item>

                <Form.Item label="สีสถานะ/Colors" name="colors">
                  <Card.Grid style={gridStyle}></Card.Grid>
                  <TwitterPicker
                    colors={[
                      "#FF6900",
                      "#FCB900",
                      "#7BDCB5",
                      "#00D084",
                      "#8ED1FC",
                      "#0693E3",
                      "#ABB8C3",
                      "#EB144C",
                      "#F78DA7",
                      "#9900EF",
                    ]}
                    color={isColor.background}
                    onChangeComplete={(e: any) => {
                      handleChangeComplete(e);
                    }}
                  />
                </Form.Item>

                <Form.Item
                  label="สาขาที่อยู่/Branch"
                  name="branch"
                  rules={[
                    { required: true, message: "Please input your Branch!" },
                  ]}
                >
                  <Select
                    // filterOption={(input: any, option: any) =>
                    //   option.children
                    //     .toLowerCase()
                    //     .indexOf(input.toLowerCase()) >= 0
                    // }
                    showSearch
                  >
                    {optBranch}
                  </Select>
                </Form.Item>
                <Form.Item
                  label="ประเภทที่ใช้/Category Used"
                  name="categoryUses"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Category Used!",
                    },
                  ]}
                >
                  <Select
                    mode="multiple"
                    allowClear
                    // dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                    style={{ width: "100%" }}
                    showSearch
                    maxTagCount="responsive"
                    onChange={onChangeTypeTree}
                  >
                    {treatmentTypeTree}
                  </Select>
                  {/* <Select
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    showSearch
                  >
                    {optBranch}
                  </Select> */}
                </Form.Item>

                {/* <Form.Item
                  label="Type Used"
                  name="categoryUses"
                  rules={[
                    { required: true, message: "Please input your Type Used!" },
                  ]}
                >
                  <Select
                    mode="multiple"
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    style={{ width: "100%" }}
                    maxTagCount="responsive"
                  >
                    {optTypeUsed}
                  </Select>
                </Form.Item> */}
              </Col>
            </Row>
            <Row className="buttonmodal-medical">
              <Col>
                <Space>
                  <Button
                    onClick={() => {
                      setIsOpen(false);
                      formMedicalEquip.resetFields();
                    }}
                    className="cancleButton-medical"
                  >
                    ยกเลิก/Cancel
                  </Button>
                  <Button
                    className="confirmButton-medical"
                    htmlType="submit"
                    onClick={() => {
                      // if (type === "update") {
                      //   update();
                      // }
                    }}
                  >
                    บันทึกข้อมูล/Submit
                  </Button>
                </Space>
              </Col>
            </Row>
          </Form>
        </Modal>
        <Modal visible={modalDelete} footer={false}>
          <Row justify="center" style={{ marginTop: "10px" }}>
            <Col>
              <Space>
                <Button
                  onClick={() => {
                    setIsOpen(false);
                    formMedicalEquip.resetFields();
                  }}
                  className="cancleButton"
                >
                  ยกเลิก/Cancel
                </Button>
                <Button
                  className="confirmButton"
                  htmlType="submit"
                  onClick={() => {
                    // if (type === "update") {
                    //   update();
                    // }
                  }}
                >
                  ตกลง/Submit
                </Button>
              </Space>
            </Col>
          </Row>
        </Modal>
        {/* <SearchFieldSelect
          option={option}
          color="#FFF"
          onChangeOtherd={onChangeOtherd}
        /> */}
        <div
          className="input-search select-search"
          style={{ marginBottom: "0px" }}
        >
          <Select
            className="select-search"
            bordered={false}
            placeholder="Search for Name"
            suffixIcon={
              <Icon
                icon="ant-design:caret-down-filled"
                style={{ color: "#AEAEAE" }}
              />
            }
            onChange={(e) => {
              setDataSearch({ ...dataSearch, typeSearch: e });
              setIsDisable({ ...isDisable, isSearch: true });
            }}
            options={istypes}
          />
          <Input.Search
            bordered={false}
            disabled={isDisable?.isSearch ? false : true}
            onSearch={(e) => {
              searchData({ e });
            }}
          />
        </div>
        <div className="row mt-20">
          <div className="bartherWapper">
            <div className="barther-select">
              <div className="barther-title">
                {/* <Select
                  title="BRANCH :"
                  option={branch}
                  value={branchs}
                  onChange={(e) => {
                    setBranchs(e.target.value);
                  }}
                /> */}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                // marginTop: "20px",
              }}
            >
              <MainButton
                title="CREATE MEDICAL EQUIPMENT"
                onClick={() => {
                  setTypes("CREATE");
                  setIsOpen(true);
                  formMedicalEquip.resetFields();
                }}
              >
                <Icon
                  icon="ant-design:plus-outlined"
                  width="24"
                  height="24"
                  vFlip={true}
                  color="#FFF"
                />
              </MainButton>
            </div>
          </div>
        </div>
        <div className="row mt-20">
          <Table
            header={[
              { title: "" },
              { title: "Name", align: "center" },
              { title: "Serial Number", align: "center" },
              { title: "Category  Used", align: "center" },
              { title: "Branch", align: "center" },
              { title: "Last Edit", align: "center" },
              { title: "Action", align: "center", colspan: 2 },
            ]}
          >
            {state.map((item: any, index: number) => (
              <tr key={index} style={{ cursor: "pointer" }}>
                <TableColumn width="3%">{index + 1}</TableColumn>
                <TableColumn align="center" width="8%">
                  {item.name}
                </TableColumn>
                <TableColumn width="3%">{item.serialNumber}</TableColumn>
                <TableColumn width="8%" align="center">
                  {item?.categoryUses.map((item: any, index: number) => (
                    <div>-{item.name}</div>
                  ))}
                </TableColumn>
                <TableColumn width="5%" align="center">
                  {item?.branch?.name}
                </TableColumn>
                <TableColumn width="5%" align="center">
                  {item.formatUpdatedAt}
                </TableColumn>
                <TableColumn width="1%" align="center">
                  <div
                    onClick={() => {
                      setIsOpen(true);
                      getOneById(item);
                      setTypes("UPDATE");
                    }}
                  >
                    <Icon
                      icon="el:pencil-alt"
                      rotate={3}
                      vFlip={true}
                      color="#5BAEA9"
                      width="20"
                      height="20"
                    />
                  </div>
                </TableColumn>
                <TableColumn width="1%" align="center">
                  <div
                    onClick={() => {
                      showDeleteConfirm(item._id, item.name);
                      // setModalDetele(true);
                    }}
                  >
                    <Icon
                      icon="fa-solid:trash-alt"
                      color="#FF6760"
                      width="20"
                      height="20"
                    />
                  </div>
                </TableColumn>
              </tr>
            ))}
          </Table>
        </div>
        <Row justify="end" className="pagination-medical">
          <Pagination
            defaultCurrent={page}
            total={countPage}
            onChange={(e: any) => {
              onchangePage(e);
            }}
          />
        </Row>
      </div>
    </>
  );
};
export default MedicalEquipment;
